import { FormControl, MenuItem, Select } from "@mui/material";
import React from "react";
import { CustomStatusBadge } from "./StatusBadge";

export default function CustomSelectStatusBadge({
  value = "",
  name = "",
  options = [],
  onChange = () => {},
  ...props
}) {
  return (
    <FormControl fullWidth size="small">
      <Select
        name={name}
        value={value}
        fullWidth
        onChange={onChange}
        {...props}
      >
        {options.map((item, itemIndex) => (
          <MenuItem value={item?.id} key={itemIndex}>
            <CustomStatusBadge
              size="small"
              variant={item?.variant}
              text={item?.label}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
